import {useRpcSender} from "../RpcSender";
import {useState} from "react";
import {RpcState} from "../RpcState";
import {DeleteBookingRequest, DeleteBookingResponse, IDeleteBookingRequest} from "../../provider_api";

type SendProps = {
  request: IDeleteBookingRequest,
  onSuccess: (bookingId: string) => void,
  onError?: (message: string) => void,
}

export const useDeleteClassBookingRpc = () => {
  
  const rpcSender = useRpcSender();
  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'});

  const send = (props: SendProps) => {

    setRpcState({state: 'pending'});
    rpcSender.send('delete_class_booking', DeleteBookingRequest.encode(props.request).finish())
        .then(value => {
          const response = DeleteBookingResponse.decode(value);
          if (response.okay) {
            setRpcState({state: 'success'});
            props.onSuccess(response.deletedBookingId);
          } else {
            setRpcState({state: 'error', message: 'Server error deleting booking'});
          }
        })
        .catch(e => {
          console.log('error', e);
          props.onError && props.onError(e);
          setRpcState({state: 'error', message: 'Network error deleting booking'});
        });
  }

  return {rpcState, send}
}